"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var declarations_1 = require("./declarations");
var getDeltaMode = function (mode) { return declarations_1.DELTA_MODE[mode] || declarations_1.DELTA_MODE[0]; };
function normalizeWheelDelta(event) {
    if ('deltaX' in event) {
        var mode = getDeltaMode(event.deltaMode);
        return {
            x: event.deltaX / declarations_1.DELTA_SCALE.STANDARD * mode,
            y: event.deltaY / declarations_1.DELTA_SCALE.STANDARD * mode,
        };
    }
    if ('wheelDeltaX' in event) {
        return {
            x: event.wheelDeltaX / declarations_1.DELTA_SCALE.OTHERS,
            y: event.wheelDeltaY / declarations_1.DELTA_SCALE.OTHERS,
        };
    }
    // ie with touchpad
    return {
        x: 0,
        y: event.wheelDelta / declarations_1.DELTA_SCALE.OTHERS,
    };
}
exports.normalizeWheelDelta = normalizeWheelDelta;
function normalizeKeyDelta(keycode) {
    var delta = { x: 0, y: 0 };
    switch (true) {
        case keycode === declarations_1.KEYCODE.SPACE:
            delta = { x: 0, y: window.innerHeight };
            break;
        case keycode === declarations_1.KEYCODE.DOWN:
            delta = { x: 0, y: 80 };
            break;
        case keycode === declarations_1.KEYCODE.UP:
            delta = { x: 0, y: -80 };
            break;
        case keycode === declarations_1.KEYCODE.RIGHT:
            delta = { x: 80, y: 0 };
            break;
        case keycode === declarations_1.KEYCODE.LEFT:
            delta = { x: -80, y: 0 };
            break;
        default:
            delta = { x: 0, y: 0 };
    }
    return delta;
}
exports.normalizeKeyDelta = normalizeKeyDelta;
;
function getTouch(list, id) {
    var found = undefined;
    for (var i = 0; i < list.length; i++) {
        if (list[i].identifier === id) {
            found = list[i];
            break;
        }
    }
    return found;
}
exports.getTouch = getTouch;
